import React from 'react';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { QQShare } from '@ifeng-fe/three_terminal/es/mobile/qqShare/dynamic';

const SecondShare = () => {
    const title = '鳳凰衛視“發現新主播”第二季招募行動正式開啟。';
    const desc = '想成為鳳凰衛視主持人、主播、出鏡記者就快來報名參加選拔吧！';
    const img = 'https://x0.ifengimg.com/ucms/2025_24/22D5A8C7696250DAF1D64ABAD0DD79CD7C374D51_size230_w600_h600.png';

    const qqShareConfig = {
        title,
        img,
        desc,
        appType: 'newsApp',
        cb: () => {},
    };

    document.getElementById('ifeng_share_title').innerHTML = title;
    document.getElementById('ifeng_share_thumbnail').innerHTML = img;
    document.getElementById('ifeng_share_description').innerHTML = desc;

    return <QQShare content={qqShareConfig} />;
};

export default errorBoundary(SecondShare);
